import React from 'react';
import {
	AdvancedSearchFooter,
	type AdvancedSearchFooterProps,
} from '../../../../advanced-search-footer/advanced-search-footer';
import { type ProductStates } from '../../../../product-state-machine/product-state-machine-types';
import { SearchFooter } from '@atlassian/search-dialog';

export const GetDefaultFooter: ({
	productState,
	...rest
}: {
	productState: ProductStates;
} & AdvancedSearchFooterProps) => React.JSX.Element = ({
	productState,
	...rest
}: {
	productState: ProductStates;
} & AdvancedSearchFooterProps) => {
	return (
		<SearchFooter>
			<AdvancedSearchFooter {...rest} />
		</SearchFooter>
	);
};
